import {
  ICheckPay,
  RESULT_PAYMENT,
  SERVICE_TYPE,
} from 'shared/api/check-payment/model'

export const getPreviewPayment = (
  params: URLSearchParams,
  isDev: boolean,
): ICheckPay | null => {
  if (!isDev || params.get('preview') !== '1') return null

  const service_type = Object.values(SERVICE_TYPE).find(
    (value) => value === params.get('service_type'),
  )
  const status = Object.values(RESULT_PAYMENT).find(
    (value) => value === params.get('status'),
  )

  return service_type && status ? { service_type, status } : null
}
